export default "__VITE_ASSET__DN2WM934__"